import "./Menu.css";
import { Link, useLocation } from "react-router-dom";

function Menu() {
  const location = useLocation();
  console.log(window.location.pathname);
  return (
    <nav className='navigation'>
      <ul className='navigation__list'>
        <li className='navigation__list-item'>
          <Link className={location.pathname === "/" ? "active" : ""} to='/'>
            Home
          </Link>
        </li>
        <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/namethings" ? "active" : ""}
            to='/namethings'
          >
            Name 3 things
          </Link>
        </li>
        <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/favs" ? "active" : ""}
            to='/favs'
          >
            Your favourites
          </Link>
        </li>
        <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/guess" ? "active" : ""}
            to='/guess'
          >
            Guessing game
          </Link>
        </li>
        <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/hangman" ? "active" : ""}
            to='/hangman'
          >
            Hangman
          </Link>
        </li>
        {/* <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/puzzles" ? "active" : ""}
            to='/puzzles'
          >
            Puzzles
          </Link>
        </li> */}
      </ul>
    </nav>
  );
}

export default Menu;
